'use strict';
var React = require('react');
var Components = require('./Components.jsx');
var ScrollView = require('osx-scrollview');

var Log = require('../Mixin/Log');

// 是否启用延迟加载, 启用后, 第一次只加载页面内能看到的内容, 稍后再加载所有内容
var ENABLE_DELAY_RENDER = false;

var Middle = React.createClass({
  propTypes: {
    screenSize: React.PropTypes.shape({
      width: React.PropTypes.string,
      height: React.PropTypes.string
    }).isRequired,
    pageSize: React.PropTypes.shape({
      width: React.PropTypes.number,
      height: React.PropTypes.number
    }).isRequired,
    domSize: React.PropTypes.shape({
      width: React.PropTypes.number,
      height: React.PropTypes.number
    }),
    top: React.PropTypes.number.isRequired,
    bottom: React.PropTypes.number.isRequired,
    events: React.PropTypes.object.isRequired,
    canFix: React.PropTypes.bool.isRequired,
    onLinkClick: React.PropTypes.func.isRequired
  },
  getInitialState: function () {
    return this.getState(this.props);
  },
  getState: function (props) {
    var renderComponents = [];
    var delayRenderComponents = [];
    var top = this.props.top;
    var bottom = parseInt(this.props.screenSize.height, 10);

    if (!ENABLE_DELAY_RENDER) {
      return {
        components: props.components,
        delayRenderComponents: []
      };
    }
    props.components.forEach(function (item) {
      if (item.y >= top && item.y <= bottom) {
        renderComponents.push(item);
      } else {
        delayRenderComponents.push(item);
      }
    });
    return {
      components: renderComponents,
      delayRenderComponents: delayRenderComponents
    };
  },
  componentWillReceiveProps: function (nextProps) {
    this.setState(this.getState(nextProps));
  },
  componentDidMount: function () {
    this.renderDelayedComponents();
  },
  componentDidUpdate: function () {
    this.renderDelayedComponents();
  },
  renderDelayedComponents: function () {
    if (this.state.delayRenderComponents.length > 0) {
      this.setState({
        components: this.state.components.concat(this.state.delayRenderComponents),
        delayRenderComponents: []
      });
    }
  },
  render: function () {
    var scrollViewHeight;
    var domSize = this.props.domSize;
    if (domSize) {
      scrollViewHeight = Math.min(domSize.height, this.props.screenSize.height) - this.props.top - this.props.bottom;
    } else {
      scrollViewHeight = this.props.screenSize.height - this.props.top - this.props.bottom;
    }
    var style = {
      width: '100%',
      height: scrollViewHeight,
      overflow: 'auto',
      top: this.props.top
    };
    if (!this.props.canFix) {
      style.height = '100%';
    }
    return (
      <div key="middle-page"
           className='page-middle'
           style={style}>
        <ScrollView>
          <div className='page-container'
               style={{
                 marginTop: -this.props.top,
                 height: this.props.pageSize.height - this.props.bottom,
                 width: this.props.pageSize.width
               }}>
            <Components components={this.state.components} events={this.props.events}/>
          </div>
        </ScrollView>
      </div>
    );
  }
});

module.exports = Middle;



/** WEBPACK FOOTER **
 ** ./src/views/Page/Middle.jsx
 **/